import {GetExamsAvailableTimesParams} from 'domain/usecases';
import {makeGetExamsAvailableTimes} from 'main/factories/usecases';
import {sortAvailableTimes, sortByKey} from 'presentation/utils';

async function getExamsAvailableTimes(params: GetExamsAvailableTimesParams) {
	const examsAvailableTimes = await makeGetExamsAvailableTimes().get(params);

	if (!examsAvailableTimes) {
		return [];
	}

	const {horariosDisponiveis} = examsAvailableTimes;
	const parsedResponse = horariosDisponiveis.map(item => ({
		professionalName: item.nmPrestadorFisico,
		professionalCode: String(item.cdPrestadorFisico),
		availableTimes: sortAvailableTimes(item.horariosDisponiveis),
		recommendations: item.dsRecomendacoes,
	}));
	const sortedAvailableTimesByProviderName = sortByKey(parsedResponse, 'professionalName');

	return sortedAvailableTimesByProviderName;
}

export {getExamsAvailableTimes};
